import React, { FC } from "react";
import { ButtonProps, CircularProgress, Button as MuiButton } from "@mui/material";

type Button = {
  children: React.ReactNode | string;
  isLoading?: boolean;
  target?: "_blank" | "_self" | "_parent" | "_top";
} & ButtonProps;

// TODO: button should use default loading state from MUI - update to 6.4.0 and use LoadingButton component

const Button: FC<Button> = ({ children, isLoading, ...props }) => (
  <MuiButton
    {...props}
    disabled={isLoading || props.disabled}
    startIcon={props.startIcon}
  >
    {isLoading && (
      <CircularProgress
        size={
          props.size === "medium" || props.size === "large"
            ? 20
            : props.size === "small"
              ? 16
              : 12
        }
        color="inherit"
        sx={{ mr: 1 }}
      />
    )}
    {children}
  </MuiButton>
);

export default Button;
